import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    minWidth: 150,
  },
}));

const CommonButton = (props) => {
  const {
    color, variant, size, children, className, basic,
  } = props;
  const classes = useStyles();
  const color1 = color !== undefined ? color : 'primary';
  const variant1 = variant !== undefined ? variant : 'outlined';
  const size1 = size !== undefined ? size : 'small';
  const basic1 = basic !== undefined ? basic : false;
  if (basic1) {
    return (
      <Button {...props} color={color}>
        {props.children}
      </Button>
    );
  }
  return (
    <Button
      {...props}
      variant={variant1}
      color={color1}
      size={size1}
      className={clsx(classes.root, className)}
    >
      {children}
    </Button>
  );
};

export default CommonButton;
